/* @flow weak */
import * as React from 'react';
import Modal from 'react-modal';
import { WithRouterProps } from 'react-router';

import Select from 'components/Select';
import Button from 'components/ButtonDeprecated';
import Columns2 from 'components/Columns2';
import ConfirmDialog from 'components/ConfirmDialog';
import Field from 'components/Field';
import Fieldset from 'components/Fieldset';
import Label from 'components/Label';
import Legend from 'components/Legend';
import SubscriberActions from 'actions/SubscriberActions';
import SettingsContainer from './SettingsContainer';
import CurrentUser from 'auth/CurrentUser';
import { ALL_TOKENS_ITEM } from 'components/Tokenizer';
import { withRouter } from 'app/context/Router';
import SETTINGS_ROUTES from 'settings/constants/SettingsRouteConstants';

import type { LoadOwnedGroupSummaries_me_classes } from 'groups/queries/__generated__/LoadOwnedGroupSummaries';

const ALL_CLASSES_OPTION = { label: 'All classes', value: ALL_TOKENS_ITEM };

type Props = {
  groups: LoadOwnedGroupSummaries_me_classes[],
} & WithRouterProps;

class PrintSubscribers extends React.Component<Props, $FlowFixMeState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      group: ALL_CLASSES_OPTION,
      groupOptions: this.getFormattedGroupSelectOptions(),
      showEmailRequiredModal: false,
    };
  }

  getFormattedGroupSelectOptions = () => {
    return [ALL_CLASSES_OPTION].concat(
      this.props.groups.map(group => {
        return { label: group.class_name, value: group.id };
      })
    );
  };

  setSelectedGroup = value => {
    const group = this.state.groupOptions.find(option => option.value === value);
    this.setState({ group });
  };

  hasSelectedGroup = () => {
    return this.state.group !== null;
  };

  printSubscribers = (): void => {
    if (!CurrentUser.hasEmail()) {
      this.toggleShowEmailRequiredModal();
      return;
    }

    let groupIds;

    // if selected group is all class pass an empty array.
    const allGroups = ALL_CLASSES_OPTION.value;
    if (this.state.group.value === allGroups) {
      groupIds = [];
    } else {
      groupIds = [this.state.group.value];
    }

    SubscriberActions.export(groupIds);
  };

  toggleShowEmailRequiredModal = () => {
    this.setState({
      showEmailRequiredModal: !this.state.showEmailRequiredModal,
    });
  };

  render() {
    return (
      <div className="PrintSubscribers PrintSettingSection">
        <Modal isOpen={this.state.showEmailRequiredModal}>
          <ConfirmDialog
            title="Add an email address to your account first"
            subtext="PDF is sent to your email. You can add an email address in your account settings."
            actionButtonText="Go to Settings"
            cancelButtonText="Cancel"
            onConfirm={() => this.props.router.push(SETTINGS_ROUTES.NOTIFICATIONS)}
            onCancel={this.toggleShowEmailRequiredModal}
            onRequestHide={this.toggleShowEmailRequiredModal}
            eventKey="print_subscribers.no_email_modal.view"
          />
        </Modal>
        <Fieldset>
          <Legend>
            Participants
            <p>Export PDFs of all the participants in your classes.</p>
          </Legend>

          <SettingsContainer>
            <Columns2 gutter="small">
              <Field>
                <Label>Class</Label>
                <Select
                  ref="select"
                  options={this.state.groupOptions}
                  value={this.state.group.value}
                  onChange={this.setSelectedGroup}
                />
              </Field>
            </Columns2>
          </SettingsContainer>

          <Button
            data-test="export-subscribers-button"
            size="small"
            disabled={!this.hasSelectedGroup()}
            onClick={this.printSubscribers}>
            Export
          </Button>
        </Fieldset>
      </div>
    );
  }
}

export { PrintSubscribers };
export default withRouter(PrintSubscribers);
